<template>
  <div>
    <nav class="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <li><router-link to="/products">Products</router-link></li>
        <li><router-link v-bind:to="`/products/${this.$route.params.product_id}`">{{ this.$store.state.product.name }}</router-link></li>
        <li class="is-active"><a href="#" aria-current="page">Smart things</a></li>
      </ul>
    </nav>

    <nav class="level">
      <div class="level-left"></div>
      <div class="level-right">
        <div class="level-item">
          <p>Total: <strong>{{ this.$store.state.productThingsTotal | numberDisplay }}</strong> smart things</p>
        </div>

        <div class="level-item">
          <div class="field has-addons">
            <div class="control">
              <input v-model="searchValue" class="input" type="text" placeholder="Find by" v-on:keyup.enter="searchThings">
            </div>
            <div class="control">
              <span class="select">
                <select v-model="searchKey">
                  <option value="name">name</option>
                  <option value="identifier">identifier</option>
                </select>
              </span>
            </div>
            <div class="control">
              <button class="button is-primary" v-on:click="searchThings">Search</button>
            </div>
          </div>
        </div>
      </div>
    </nav>

    <pagination
      v-bind:urlBuilder="buildPaginatorUrls"
      v-bind:currentPage="currentPage"
      v-bind:lastPage="lastPage"
      v-bind:displayPage="5"
      class="is-small" />

    <table class="table is-striped is-fullwidth">
      <thead>
        <tr>
          <th>ID</th>
          <th>Name</th>
          <th>Identifier</th>
          <th>Firmware version</th>
          <th>Created at</th>
          <th>Updated at</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="!this.$store.state.productThings.length">
          <td colspan="5" class="has-text-centered has-text-grey">No smart things found</td>
        </tr>
        <tr v-for="item in this.$store.state.productThings">
          <td>{{ item.id }}</td>
          <td><router-link v-bind:to="`/products/${item.product_id}/things/${item.id}`">{{ item.name || 'No name' }}</router-link></td>
          <td>{{ item.identifier }}</td>
          <td>{{ item.value }}</td>
          <td>{{ item.created_at }}</td>
          <td>{{ item.updated_at }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import Pagination from 'vue-bulma-pagination'

  export default {
    data () {
      return {
        searchValue: this.$route.query.name ||
          this.$route.query.identifier ||
          '',
        searchKey: this.$route.query.name ? 'name'
          : this.$route.query.identifier ? 'identifier'
          : 'name',

        searchParams: {}
      }
    },

    computed: {
      currentPage () {
        return parseInt(this.$route.query.page) || 1
      },

      lastPage () {
        return Math.ceil(this.$store.state.productThingsTotal / 20)
      }
    },

    methods: {
      buildPaginatorUrls (page) {
        return { query: { ...this.$route.query, page } }
      },

      searchThings () {
        this.searchParams[this.searchKey] = this.searchValue
        this.searchParams.created_after = this.createdAfter
        this.searchParams.created_before = this.createdBefore

        // Clean empty fields
        Object.keys(this.searchParams)
          .filter(key => !this.searchParams[key])
          .forEach(key => delete this.searchParams[key])

        this.$router.push({
          path: `/products/${this.$route.params.product_id}/things`,
          query: this.searchParams
        })
      }
    },

    created () {
      this.$store.dispatch('getProduct', {
        productId: this.$route.params.product_id
      })

      this.$store.dispatch('getProductThings', {
        productId: this.$route.params.product_id,
        params: this.$route.query
      })
    },

    watch: {
      '$route.query' (query) {
        this.$store.dispatch('getProductThings', {
          productId: this.$route.params.product_id,
          params: this.$route.query
        })
      },

      // Delete old search parameter
      // to prevent sending two parameters at the same time
      // because the form visually doesn't support this case
      searchKey (newSearchKey, oldSearchKey) {
        delete this.searchParams[oldSearchKey]
      }
    },

    components: {
      Pagination
    }
  }
</script>



// WEBPACK FOOTER //
// ThingList.vue?c2c4e692